import { render, staticRenderFns } from "./BusinessNameDataUpdateApplications.vue?vue&type=template&id=2511c1b7&scoped=true&"
import script from "./BusinessNameDataUpdateApplications.vue?vue&type=script&lang=js&"
export * from "./BusinessNameDataUpdateApplications.vue?vue&type=script&lang=js&"
import style0 from "./BusinessNameDataUpdateApplications.vue?vue&type=style&index=0&id=2511c1b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2511c1b7",
  null
  
)

export default component.exports